/**********  CSS for all  **********/
import './TagsStyle/button.css'
import './TagsStyle/h.css'
import './TagsStyle/form.css'
import './TagsStyle/input.css'

/**************  CSS  **************/
import './App.css'

/**********  Components  ***********/
import MainPage from './Pages/MainPage/MainPage'

/************  Others  *************/
//Fontawesome. On all others files, use this: import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(fas, far)

export default function App() {
    return <div>
        <MainPage />
    </div>
}